var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'moral-result-list',
  created () {
    utils.moralBackClear()
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    morals () {
      return this.$store.getters.moralResultList
    },
    nextPage () {
      return this.$store.getters.moralResultListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    moralResultData () {
      return this.$store.getters.moralResultData
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.moralResultListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {}
      this.$store.dispatch('MORAL_RESULT_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goMoralDetail: function(moralId) {
      window.sessionStorage.setItem('moral_result', 'on')
      this.$router.push({ path: '/morals/' + moralId })
    },
    goDataDownload: function(moralId) {
      var self = this
      var data = {}
      data.moral_id = moralId
      var callback = function() {
        self.csvFileName = 'error.csv'
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var mimeType = 'text/csv'
        var csvDefaultHeader = 'タイトル,店舗名,ID,氏名,ふりがな,役職名,回答状態,回答日'
        var currentMoralResultId = null
        var csvLineBuffer = []
        var csvHeaderBuffer = ''
        var csvBodyBuffer = ''
        var contentAnswerBuffer = ''
        var contentAnswerIndex = 1
        var csvHeader = ''

        self.moralResultData.forEach(function (obj) {
          if (currentMoralResultId != null && currentMoralResultId != obj.attributes['moral-result-id']) {
            csvHeader = csvDefaultHeader + csvHeaderBuffer + "\n"
            var line = csvBodyBuffer + contentAnswerBuffer + "\n"
            csvLineBuffer.push(line)
            currentMoralResultId = null
            csvHeaderBuffer = ''
            csvBodyBuffer = ''
            contentAnswerBuffer = ''
            contentAnswerIndex = 1
          }
          if (!currentMoralResultId) {
            currentMoralResultId = obj.attributes['moral-result-id']
            self.csvFileName = obj.attributes['moral-title'] + '.csv'

            if (obj.attributes['moral-title']) {
              csvBodyBuffer += self.enquoteForCSV(obj.attributes['moral-title']) + ','
            } else {
              csvBodyBuffer += ','
            }
            if (obj.attributes['shop-name']) {
              csvBodyBuffer += self.enquoteForCSV(obj.attributes['shop-name']) + ','
            } else {
              csvBodyBuffer += ','
            }
            if (obj.attributes['user-id']) {
              csvBodyBuffer += self.enquoteForCSV(obj.attributes['user-id']) + ','
            } else {
              csvBodyBuffer += ','
            }
            if (obj.attributes['user-name']) {
              csvBodyBuffer += self.enquoteForCSV(obj.attributes['user-name']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname']) + ','
            } else {
              csvBodyBuffer += ','
            }
            if (obj.attributes['user-name-furigana'] && obj.attributes['user-firstname-furigana']) {
              csvBodyBuffer += self.enquoteForCSV(obj.attributes['user-name-furigana']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname-furigana']) + ','
            } else {
              csvBodyBuffer += ','
            }
            if (obj.attributes['user-type-name']) {
              csvBodyBuffer += self.enquoteForCSV(obj.attributes['user-type-name']) + ','
            } else {
              csvBodyBuffer += ','
            }
            if (obj.attributes['last-detail-id'] == null) {
              csvBodyBuffer += '未回答,'
            } else if (obj.attributes['is-result-send'] == 0) {
              csvBodyBuffer += '回答中,'
            } else {
              csvBodyBuffer += '回答済,' + obj.attributes['answered-at-format']
            }
          }
          csvHeaderBuffer += ',' + self.enquoteForCSV(obj.attributes['sub-title'])
          if (obj.attributes['answer'] == "yes") {
            contentAnswerBuffer += ',0'
          } else if (obj.attributes['answer'] == "no") {
            contentAnswerBuffer += ',1'
          } else {
            contentAnswerBuffer += ','
          }
          contentAnswerIndex++
        })
        if (currentMoralResultId != null) {
          if (!csvHeader) {
            csvHeader = csvDefaultHeader + csvHeaderBuffer + "\n"
          }
          var line = csvBodyBuffer + contentAnswerBuffer + "\n"
          csvLineBuffer.push(line)
        }
        var csv = csvHeader
        for(var i in csvLineBuffer) {
          csv += csvLineBuffer[i]
        }

        var blob = new Blob([bom, csv], { type: mimeType })
        var hiddenElement = document.createElement('a')
        hiddenElement.download = self.csvFileName
        hiddenElement.target = '_blank'
        if(window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, self.csvFileName)
        } else if (window.URL && window.URL.createObjectURL){
          hiddenElement.href = window.URL.createObjectURL(blob)
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
          hiddenElement.click()
        } else {
          window.open('data:' + mimeType + ';base64,' + window.Base64.encode(content), '_blank')
        }
      }
      self.$store.dispatch('MORAL_RESULT_DATA_DOWNLOAD',{ data : data, callback : callback })
    },
    enquoteForCSV: function(val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-result-list.js